import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, LOGO_URL } from "@/lib/branding";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-24 bg-black">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="ball0ut.ent" className="h-12 w-12 object-contain" />
            <div className="font-display text-3xl tracking-tight">
              <span className="text-white">BALL0UT</span><span className="text-brand-primary">TV</span>
            </div>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/80 mb-3">Watch</div>
          <ul className="space-y-2 text-sm text-brand-muted">
            <li><Link to="/browse" className="hover:text-white" data-testid="footer-browse-link">Browse all</Link></li>
            <li><Link to="/show/boyz-gone-wild" className="hover:text-white" data-testid="footer-show-link">Boyz Gone Wild</Link></li>
            <li><Link to="/subscribe" className="hover:text-white" data-testid="footer-subscribe-link">Subscribe</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/80 mb-3">Follow</div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 text-brand-muted hover:text-brand-primary"
          >
            <Instagram className="h-5 w-5" /> @ball0ut.ent
          </a>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-brand-muted tracking-wide">
        © {new Date().getFullYear()} BallOutTV. ball0ut.ent Productions. All rights reserved.
      </div>
    </footer>
  );
}
